export default __webpack_public_path__ + "static/media/TransportationBoats_09.3b64bf12.png";